export default __webpack_public_path__ + "static/m-team-2-c7f0d32dbb931ce946851380610fea2d.jpg";